import { motion, useInView } from "framer-motion"
import { Link, graphql } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import Modal from "react-modal"
import ImageOpt from "./../ImageOpt"

const ImageWithContent = ({ module }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  const [modalIsOpen, setIsOpen] = React.useState(false)
  const [modalData, setModalData] = React.useState(false)

  function openModal(data) {
    setModalData(data)
    document.body.classList.add("modal-open")
    setIsOpen(true)
  }

  function closeModal() {
    document.body.classList.remove("modal-open")
    setIsOpen(false)
  }

  const zigzagmodal = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "0",
      border: "0",
      borderRadius: "0",
      width: "100%",
      height: "100%",
      backgroundColor: "#FFFFFF",
    },
    overlay: {
      zIndex: "99",
    },
  }

  if (module.hideSection === "no") {
    return (
      <>
        <section
          className={`zigzag ${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          <div className="container-fluid">
            <div className="bg-white-100 py-40 px-80 lgscreen:px-30 lgscreen:py-20 pb-120 lgscreen:pb-30">
              <motion.div
                initial="hidden"
                animate={isInView || hasPlayed ? "show" : "hidden"}
                variants={sectionShow}
                className="anim"
              >
                <motion.div
                  ref={ref}
                  initial="hidden"
                  animate={isInView || hasPlayed ? "show" : "hidden"}
                  variants={sectionShow}
                  className="anim"
                >
                  <div className="flex flex-wrap items-center">
                    <motion.div
                      variants={animFade}
                      className={`lg:w-6/12 w-full ${
                        module?.imagePosition === "right"
                          ? "order-2 lgscreen:order-1"
                          : ""
                      }`}
                    >
                      {module?.image && (
                        <div className={`img ${module.imageSize}`}>
                          <ImageOpt
                            imgData={module.image.mediaItemUrl}
                            width={2424}
                            height={1467}
                            imgAlt={module.image.altText}
                            imgLoad="lazy"
                            imgClass="w-full object-cover"
                          />
                        </div>
                      )}
                    </motion.div>
                    <div
                      className={`lg:w-6/12 w-full ${
                        module?.imagePosition === "right"
                          ? "order-1 lgscreen:order-2"
                          : ""
                      }`}
                    >
                      <div
                        className={`zigzag-content laptop:px-40 lgscreen:px-0 lgscreen:pt-30 ${
                          module?.imagePosition === "right"
                            ? "pl-40 pr-75"
                            : "pr-40 pl-80"
                        }`}
                      >
                        {module?.preHeading && (
                          <div className="preheading mb-5 lgscreen:mb-15">
                            <motion.div
                              variants={animFade}
                              className="font-ositalic text-16 text-charcoal"
                            >
                              {module.preHeading}
                            </motion.div>
                          </div>
                        )}
                        {module?.heading && (
                          <motion.h3 variants={animFade}>
                            {parse(module.heading)}
                          </motion.h3>
                        )}
                        {module?.information && (
                          <motion.div
                            variants={animFade}
                            className="flex flex-wrap gap-x-5 py-10"
                          >
                            {module.information.map((item, i) => (
                              <div
                                className="flex flex-wrap items-center gap-x-[5px]"
                                key={i}
                              >
                                {item?.icon && (
                                  <img
                                    src={item.icon.mediaItemUrl}
                                    width={12}
                                    height={12}
                                    loading="lazy"
                                    alt="history"
                                  />
                                )}
                                {item?.iconText && (
                                  <span className="font-ositalic text-13">
                                    {item.iconText}
                                  </span>
                                )}
                              </div>
                            ))}
                          </motion.div>
                        )}
                        {module?.description && (
                          <motion.div
                            variants={animFade}
                            className="content pt-10"
                          >
                            {parse(module.description)}
                          </motion.div>
                        )}
                        <div className="flex flex-wrap gap-x-2 mt-20 gap-y-2">
                          {module?.book && (
                            <motion.div
                              variants={animFade}
                              className="smscreen:w-full"
                            >
                              <Link
                                to={module.book.url}
                                className="btn btn-black"
                                target={module.book.target}
                              >
                                {module.book.title}
                              </Link>
                            </motion.div>
                          )}
                          {module?.explore && (
                            <motion.div
                              variants={animFade}
                              className="smscreen:w-full"
                            >
                              {module.addPopup === "yes" ? (
                                <button
                                  className="btn btn-border"
                                  onClick={() => {
                                    openModal(module.popup)
                                  }}
                                >
                                  explore
                                </button>
                              ) : (
                                <Link
                                  to={module.explore.url}
                                  className="btn btn-border"
                                  target={module.explore.target}
                                >
                                  {module.explore.title}
                                </Link>
                              )}
                            </motion.div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </motion.div>
            </div>
          </div>
        </section>
        {module.addPopup === "yes" && (
          <Modal
            isOpen={modalIsOpen}
            style={zigzagmodal}
            onRequestClose={closeModal}
            contentLabel="Example Modal"
            ariaHideApp={false}
            id="whatson-details"
          >
            <div variants={animFade} className="zigzag-modal-popup h-full">
              <motion.div variants={animFade}>
                <button
                  onClick={closeModal}
                  className="absolute right-70 top-45 z-9 lgscreen:right-30 lgscreen:top-30 lgscreen:w-30 lgscreen:h-30 lgscreen:bg-white-100 lgscreen:rounded-100  flex items-center justify-center w-[40px] h-[40px] rounded-100"
                >
                  <img
                    src="../images/close.svg"
                    className="lgscreen:w-10"
                    width={15}
                    height={15}
                    loading="lazy"
                    alt="Close"
                  />
                </button>
              </motion.div>
              <div className="flex flex-wrap items-center h-full">
                {module.popup?.popupImage && (
                  <div className="lg:w-5/12 w-full h-full mdscreen:h-auto relative">
                    <div className="img h-full">
                      <ImageOpt
                        imgData={module.popup?.popupImage.mediaItemUrl}
                        imgAlt={module.popup?.popupImage.altText}
                        imgClass="w-full h-screen lgscreen:h-full object-cover"
                        width={1500}
                        height={900}
                        imgLoad="lazy"
                      />
                    </div>
                  </div>
                )}
                <div className="lg:w-7/12 w-full">
                  <div className="px-100 laptop:px-50 lgscreen:px-20 lgscreen:py-30">
                    <div className="preheading mb-5 lgscreen:mb-15">
                      {module.popup?.preheading && (
                        <span className="font-ositalic text-16 text-charcoal capitalize">
                          {module.popup?.preheading}
                        </span>
                      )}
                    </div>
                    <motion.h3 variants={animFade}>
                      {module.popup?.title}
                    </motion.h3>
                    <motion.div
                      variants={animFade}
                      className="flex flex-wrap gap-x-3 py-10"
                    >
                      {module.popup?.time && (
                        <div className="flex flex-wrap items-center gap-x-[5px]">
                          <img
                            src="../images/history.svg"
                            className="relative -top-2"
                            width={12}
                            height={12}
                            loading="lazy"
                            alt="Clock"
                          />
                          <span className="font-ositalic text-13">
                            {module.popup?.time}
                          </span>
                        </div>
                      )}
                      {module.popup?.eventDate && (
                        <div className="flex flex-wrap items-center gap-x-[5px]">
                          <img
                            src="../images/event.svg"
                            className="relative -top-2"
                            width={12}
                            height={12}
                            loading="lazy"
                            alt="Event"
                          />
                          <span className="font-ositalic text-13">
                            {module.popup?.eventDate}
                          </span>
                        </div>
                      )}
                      {module.popup?.price && (
                        <div className="flex flex-wrap items-center gap-x-[5px]">
                          <img
                            src="../images/credit-card.svg"
                            className="relative -top-2"
                            width={12}
                            height={12}
                            loading="lazy"
                            alt="Credit Card"
                          />
                          <span className="font-ositalic text-13">
                            {module.popup?.price}
                          </span>
                        </div>
                      )}
                    </motion.div>
                    {module.popup?.content && (
                      <motion.div variants={animFade} className="content">
                        {parse(module.popup?.content)}
                      </motion.div>
                    )}
                    <motion.div
                      variants={animFade}
                      className="mt-25 flex gap-x-2"
                    >
                      {module.popup?.bookNow && (
                        <Link
                          to={module.popup?.bookNow.url}
                          className="btn btn-black"
                          target={module.popup?.bookNow.target}
                        >
                          {module.popup?.bookNow.title}
                        </Link>
                      )}
                      {module.popup?.viewMenu && (
                        <Link
                          to={module.popup?.viewMenu.url}
                          className="btn btn-border"
                          target={module.popup?.viewMenu.target}
                        >
                          {module.popup?.viewMenu.title}
                        </Link>
                      )}
                    </motion.div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        )}
      </>
    )
  }
  return null
}

export default ImageWithContent
export const EatDrinkImageWithContentFragment = graphql`
  fragment EatDrinkImageWithContentFragment on WpEatDrink_Restaurantcontent_RestaurantContent_ImageWithContent {
    extraId
    extraClass
    hideSection
    heading
    preHeading
    imagePosition
    imageSize
    description
    addPopup
    popup {
      preheading
      title
      content
      time
      eventDate
      price
      bookNow {
        target
        title
        url
      }
      viewMenu {
        target
        title
        url
      }
      popupImage {
        altText
        mediaItemUrl
      }
    }
    book {
      target
      title
      url
    }
    explore {
      target
      title
      url
    }
    image {
      altText
      mediaItemUrl
    }
    information {
      iconText
      icon {
        altText
        mediaItemUrl
      }
    }
  }
`
